export const LOGO_FULL = '/assets/logos/stonehartden_logo.png';
export const LOGO_MINI = '/assets/logos/stoneharden_logo_mini.png';
export const LOGO_FAVICON = '/assets/logos/stoneharden_logo_mini.ico';

/** Future campaign art — drop files under public/banners and public/promos */
export const HOME_ASSETS = {
  heroBanner: '/banners/hero-main.jpg',
  promoBanner: '/promos/promo-strip.jpg',
} as const;

/**
 * Recommended asset sizes (docs + design handoff)
 * - Hero banner: 1920×640 (desktop), min 1280×480; mobile crop ~750×560
 * - Promo strip: 1400×200 (desktop), 750×280 (mobile stack)
 * - Recommended product card image: 400×400 (1:1), display ~160–240px wide in carousel
 * - Bento tile: 800×600 (medium/wide), 600×900 (tall)
 */
export const HOME_ASSET_SIZES = {
  hero: { width: 1920, height: 640 },
  promo: { width: 1400, height: 200 },
  productCard: { width: 400, height: 400 },
  bentoMedium: { width: 800, height: 600 },
  bentoTall: { width: 600, height: 900 },
} as const;
